import mapStyles from '@usepepper/ui/molecules/map/map-styles.json';

export const DEFAULT_ZOOM = 16;

export const DOT_MARKER_TRANSFORM = 'translate(-50%, -50%)';

export const PIN_MARKER_TRANSFORM = 'translate(-50%, -100%)';

export const MAP_OPTIONS: google.maps.MapOptions = {
  clickableIcons: false,
  disableDefaultUI: true,
  draggable: false,
  gestureHandling: 'none',
  keyboardShortcuts: false,
  styles: mapStyles,
};
